/**
 * Shopify Storefront Client
 * This class initializes the Shopify Storefront API client and attaches it to the global `window` object.
 * It provides a connection to the Shopify Storefront API using the given store domain, API version, and public access token.
 */
class ShopifyStorefrontClient {
  /**
   * Constructor initializes the Shopify Storefront API client.
   * It attaches the client to the global `window` object for accessibility throughout the application.
   */
  constructor() {
    try {
      if (!ShopifyStorefrontAPIClient) {
        console.error("ShopifyStorefrontAPIClient is not defined. Make sure the SDK is properly loaded.");
        return;
      }
      
      // Check if required variables are available
      if (!window.storefrontApiVersion) {
        console.error("storefrontApiVersion is not defined");
        return;
      }
      
      if (!window.storefrontToken) {
        console.error("storefrontToken is not defined");
        return;
      }
      
      if (!Shopify || !Shopify.shop) {
        console.error("Shopify.shop is not defined");
        return;
      }
      
      window.storefrontClient = ShopifyStorefrontAPIClient.createStorefrontApiClient({
        storeDomain: Shopify.shop,
        apiVersion: window.storefrontApiVersion,
        publicAccessToken: window.storefrontToken,
      });
    } catch (error) {
      console.error("Error initializing storefront client:", error);
    }
  }
}

// Instantiate the ShopifyStorefrontClient
new ShopifyStorefrontClient();
